import { render, staticRenderFns } from "./CrudV1.vue?vue&type=template&id=598db0ac&scoped=true&"
import script from "./CrudV1.vue?vue&type=script&lang=js&"
export * from "./CrudV1.vue?vue&type=script&lang=js&"
import style0 from "./CrudV1.vue?vue&type=style&index=0&id=598db0ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598db0ac",
  null
  
)

export default component.exports